
import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import { TweenMax } from "gsap";
import { changeNavbarTheme, getOldTheme, NavBarTheme, navDarkTheme } from "@/components/NavBar/navbar-theme";

@Component({})
export default class Menu extends Vue {
  isMenuOpen = false;
  oldProps!: NavBarTheme;
  currentPathName: string = "/";

  changeLanguage(lang: string) {
    this.$i18n.locale = lang;
    localStorage.setItem('language', lang);
  }

  get menuIcon() {
    return this.isMenuOpen ? "fa-times" : "fa-bars";
  }

  isPath(name: string): boolean {
    return !!new RegExp(name, "i").exec(this.currentPathName);
  }

  toggle() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  mounted() {
    this.selectActiveItem();

    this.$el.addEventListener(
      "mouseleave",
      ({ target }) => {
        this.selectActiveItem();
      },
      false
    );

    this.$el.addEventListener(
      "mouseover",
      ({ target }) => {
        // @ts-ignore
        if (target && target.href) {
          this.selectItem(target);
        }
      },
      false
    );
  }

  @Watch("currentPathName")
  selectActiveItem() {
    setTimeout(() => {
      const active = this.$el.querySelector(".nav-item.active");
      if (active) {
        this.selectItem(active);
      }
    }, 150);
  }

  enter() {
    const root = document.documentElement;
    this.currentPathName = this.$route.hash || this.$route.hash || this.$route.path;

    // Save current page colors.
    this.oldProps = getOldTheme();

    // Set menu navbar colors.

    changeNavbarTheme(navDarkTheme);

    this.selectActiveItem();
  }

  leave() {
    if (this.oldProps) {
      changeNavbarTheme(this.oldProps);
    }
  }

  private selectItem(target: Element | EventTarget) {
    // @ts-ignore
    const rect = target.getBoundingClientRect();
    const selector = this.$refs.menuSelector;
    if (selector) {
      TweenMax.to(selector, 0.3, {
        css: {
          opacity: 1,
          // @ts-ignore
          left: this.$vuetify.breakpoint.mdAndUp ? rect.x + rect.width / 2 : 32,
          // @ts-ignore
          top: rect.y + rect.height / 2 + (this.$vuetify.breakpoint.mdAndUp && 40)
        }
      });
    }
  }
}
